import { memo, useEffect, useRef, useState } from 'react';
import { NewsWrapper } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { selectCateNews, selectHotNews } from './selectors';
import { GET_CATE_NEWS, GET_HOT_NEWS } from './slice';
import LinkInOutApp from '@components/LinkInOutApp';
import { GET_NEWS } from '@containers/Home/slice';
import Pagination from '@components/Pagination';
import ItemNews from '@components/ItemNews';
import { selectIsLoading, selectNews } from '@containers/Home/selectors';
import useIsPc from '@utils/hooks/useIsPc';
import LoadingContainer from '@components/LoadingContainer';
import { useRouter } from 'next/router';

interface Props {
  park: string;
}

const NewsPage = memo(({ park }: Props) => {
  const newsAllRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const isPc = useIsPc();
  const router = useRouter();

  const newsHot = useSelector(selectHotNews);
  const cate = useSelector(selectCateNews);
  const news = useSelector(selectNews);
  const loading = useSelector(selectIsLoading);

  const [page, setPage] = useState(1);

  const [idNews, setIdNews] = useState('');

  useEffect(() => {
    if (router?.query?.key) {
      setIdNews(prevIdNews => {
        if (prevIdNews !== String(router.query.key)) {
          return String(router.query.key);
        }
        return prevIdNews;
      });

      const timer = setTimeout(() => {
        const { key, ...rest } = router.query;
        router.replace({ pathname: router.pathname, query: rest }, undefined, {
          shallow: true,
        });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [router.query.key, router]);

  useEffect(() => {
    if (!park) return;
    dispatch(GET_HOT_NEWS({ park }));
    dispatch(GET_CATE_NEWS({ park }));
  }, [dispatch, park]);

  useEffect(() => {
    dispatch(
      GET_NEWS({ park, page, limit: isPc ? '9' : '6', category: idNews }),
    );
    if (newsAllRef.current) {
      newsAllRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [dispatch, park, page, idNews, isPc]);

  return (
    <NewsWrapper>
      <div className="NewsHot">
        <div className="container-fluid">
          {newsHot?.data?.length > 0 &&
            newsHot?.data.slice(0, 1).map(item => (
              <LinkInOutApp
                href={`/tin-tuc/${item?.slug}`}
                className="--item --newHot link"
                key={item.id}
              >
                <div className="--txt">
                  <div className="--cate">{item?.newscategory?.name}</div>
                  <div className="--name">{item?.title}</div>
                  <div className="--time">
                    <i className="fa-regular fa-calendar"></i>
                    {item?.date}
                  </div>
                </div>
                <div className="--img">
                  <img src={item?.imageThumbnails?.thumb1600} alt="" />
                </div>
              </LinkInOutApp>
            ))}
          <div className="--listNews">
            {newsHot?.data.slice(1, 4).map(item => (
              <LinkInOutApp
                href={`/tin-tuc/${item?.slug}`}
                className="--item link "
                key={item?.id}
              >
                <div className="--txt">
                  <div className="--cate">{item?.newscategory?.name}</div>
                  <div className="--name">{item?.title}</div>
                  <div className="--time">
                    <i className="fa-regular fa-calendar"></i>
                    {item?.date}
                  </div>
                </div>
                <div className="--img">
                  <img src={item?.imageThumbnails?.thumb1000} alt="" />
                </div>
              </LinkInOutApp>
            ))}
          </div>
        </div>
      </div>
      <div className="NewsAll" ref={newsAllRef}>
        <div className="container-fluid">
          <div className="titleFrame">Danh sách tin tức</div>
          <div className="TabPage">
            {[{ id: '', name: 'Tất cả' }, ...cate].map(item => (
              <div
                key={item.id}
                className={`--item ${
                  String(item?.id) === String(idNews) ? 'active' : ''
                }`}
                onClick={() => {
                  setIdNews(item?.id);
                  setPage(1);
                }}
              >
                {item.name}
              </div>
            ))}
          </div>

          <LoadingContainer loading={loading}>
            <div className="--listNews">
              {news?.data?.map(item => <ItemNews item={item} key={item.id} />)}
            </div>
          </LoadingContainer>
          {news?.paginator?.pageCount && (
            <Pagination
              currentPage={news?.paginator?.current}
              totalPage={news?.paginator?.pageCount}
              onChangePage={newPage => setPage(newPage)}
            />
          )}
        </div>
      </div>
    </NewsWrapper>
  );
});

export default NewsPage;
